import React, { Component } from 'react';
import { isAndroid, isIOS, isBrowser } from "react-device-detect";
import app_store_logo   from '../assets/AppStore.svg';
import google_play_logo from '../assets/google-play.png';
import logo             from '../assets/logo-icon.png';
import { StringUtils, DateUtils } from '../utils';
import { Routes as routes } from '../navigation';
import { Button } from '../components';
import '../css/SignIn.css';

class DownloadApp extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ios_href: '',
      android_href: '',
    }
  }

  renderDownloadSection = () => {
    return <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 40 }}>

      <img className="sign-in-logo-image" src={logo} alt="Icon Text" />
      <span style={{ marginTop: 2, fontSize: 28, fontWeight: '600', color: '#1dc2ff' }}>teletails</span>

      <div className='flex-container-column' style={{ justifyContent: 'center', alignItems: 'center', width: 280, textAlign: 'center', marginTop: 10 }}>
        <span style={{ fontSize: 12, color: 'grey' }}>Download the TeleTails app and get access to all the features</span>
      </div>

      <div className='flex-container-row' style={{ marginTop: 25 }}>
        <a target="_blank" href='https://apps.apple.com/us/app/teletails/id1419680694'><img className="sign-in-logo-image" src={app_store_logo} style={{ width: 120 }} alt="Icon Text" /></a>
        <div style={{ width: 5 }}></div>
        <a target="_blank" href='https://play.google.com/store/apps/details?id=com.teletails&hl=en_US'> <img className="sign-in-logo-image" src={google_play_logo} style={{ width: 120 }} alt="Icon Text" /></a>
      </div>
    </div>
  }

  render() {
    return this.renderDownloadSection();
  }
}

export default DownloadApp;
